import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {HelperService} from '../services/helper.service';

export class BaseUrlInterceptor implements HttpInterceptor {
    private readonly helperService = inject(HelperService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            url: this.resolveUrl(request.url)
        });

        return next.handle(request);
    }

    private resolveUrl(url: string): string {
        const swissWebServiceConfig = this.helperService.getSwissWebServiceConfig();
        const host = swissWebServiceConfig.host || '';

        if (!host || !url.startsWith('/api/')) {
            return url;
        }

        return this.joinUrls(host, url);
    }

    private joinUrls(baseUrl: string, path: string): string {
        const cleanBase = baseUrl.replace(/\/+$/, '');
        const cleanPath = path.replace(/^\/+/, '');

        return `${cleanBase}/${cleanPath}`;
    }
}
